import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

const STUFEN = ['egal', 'wenig', 'normal', 'wichtig'];

/**
 * Worauf spielst du hin?
 *
 * Vier Stufen, mehr nicht. Feiner einstellen zu lassen würde eine
 * Genauigkeit vortäuschen, die in der Bewertung dahinter nicht steckt —
 * die Tier-Listen kennen fünf Stufen, die Besitzprüfung drei.
 *
 * "egal" ist bewusst eine echte Null: Wer PvP nicht spielt, soll dazu auch
 * keine Vorschläge bekommen.
 */
export default function ZielePage() {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);
  const [gespeichert, setGespeichert] = useState(false);

  useEffect(() => {
    api.ziele.lesen().then(setDaten).catch((e) => setFehler(e.message));
  }, []);

  const setzen = async (ziel, wert) => {
    const neu = { ...daten.ziele, [ziel]: wert };
    setDaten({ ...daten, ziele: neu });
    setGespeichert(false);

    try {
      const antwort = await api.ziele.setzen(neu);
      setDaten((d) => ({ ...d, ...antwort }));
      setGespeichert(true);
    } catch (e) {
      setFehler(e.message);
    }
  };

  if (fehler) return <div className="error">{fehler}</div>;
  if (!daten) return <div className="skeleton" style={{ height: 260 }} />;

  return (
    <section className="section">
      <h2 className="section__title">Deine Ziele</h2>
      <p className="gruppe__text">
        Danach richtet sich, was auf der Startseite oben steht. „Egal" blendet
        ein Thema vollständig aus.
        {gespeichert && <span className="ziel__gespeichert"> Gespeichert.</span>}
      </p>

      <div className="stack">
        {Object.entries(daten.katalog).map(([schluessel, info]) => (
          <div key={schluessel} className="ziel">
            <div className="ziel__text">
              <strong>{info.titel}</strong>
              <span className="card__meta">{info.text}</span>
            </div>
            <div className="ziel__stufen">
              {STUFEN.map((name, wert) => (
                <button
                  key={name}
                  className={'ziel__stufe' + (daten.ziele[schluessel] === wert ? ' ziel__stufe--an' : '')}
                  onClick={() => setzen(schluessel, wert)}
                >
                  {name}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
